export default __webpack_public_path__ + "static/media/B0000.05248df1.png";